import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import pages from '../pageMetadata.json';
export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = pages[pathname.toLowerCase().replace(/\/$/, '') || '/'] || pages['/'];
    document.title = page.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', page.description);
  }, [pathname]);
  return null;
}
